import React from "react";
import { DataRequestDetail } from "../../../../../common/models";
import { CompileProfilingInfo } from "./profilingInformation/CompileProfilingInfo";
import { SendProfilingData } from "./profilingInformation/SendProfilingData";
import { VerifyConsumer } from "./shared/VerifyConsumer";

type Props = {
  request: DataRequestDetail;
};

export const ProfilingInformationSteps: React.FC<Props> = ({ request }) => {
  switch (request.state) {
    case "VERIFY_CONSUMER":
      return <VerifyConsumer />;
    case "GET_PROFILING_INFO":
      return <CompileProfilingInfo />;
    case "SEND_DATA":
      return <SendProfilingData />;
  }
  return null;
};
